export const handleColumnTags = (col) => `<div class='ckeditor-question-${col}-column'>
<p>1) &nbsp; <span class='ckeditor-question-1'>.</span></p>
<p>2) &nbsp; <span class='ckeditor-question-2'>.</span></p>
<p>3) &nbsp; <span class='ckeditor-question-3'>.</span></p>
<p>4) &nbsp; <span class='ckeditor-question-4'>.</span></p>
</div>`;



export const poemTags = `<div class='ckeditor-poem-two-column'>
<p> <span class='ckeditor-question-poem'>.</span></p>
<p> <span class='ckeditor-question-poem'>.</span></p>
</div>`;

const response = `<div class="ckeditor-response">
<p class="ckeditor-response">گزینه «»</p>
<p class="ckeditor-response">-</p>
</div>`;

export const styles = [
    { id: 1, value: handleColumnTags('one'), title: 'یک ستون' },
    { id: 2, value: handleColumnTags('two'), title: 'دو ستون' },
    { id: 3, value: handleColumnTags('three'), title: 'سه ستون' },
    { id: 4, value: handleColumnTags('four'), title: 'چهار ستون' },
    { id: 5, value: response, title: 'جواب' },
    { id: 5, value: poemTags, title: 'بیت' },
  ];


// image items
export const image = {
    resizeOptions: [
      {
        name: 'resizeImage:original',
        value: null,
        label: 'Original size'
      },
      {
        name: 'resizeImage:25',
        value: '25%',
        label: '25%'
      },
      {
        name: 'resizeImage:50',
        value: '50%',
        label: '50%'
      },
      {
        name: 'resizeImage:75',
        value: '75%',
        label: '75%'
      }
    ],
    toolbar: [
      'imageStyle:alignLeft',
      'imageStyle:alignCenter',
      'imageStyle:alignRight',
      '|',
      'imageResize',
      '|',
      'imageTextAlternative',
       'linkImage'
    ],
    styles: [
      'full',
      'side',
      'alignLeft',
      'alignCenter',
      'alignRight'
    ],
    upload: {
      types: [ 'jpeg', 'png', 'svg' ],
      maxSize: 1024 * 1024,
      quality: 0.8
    }
  };

  
  export const toolbar = {
    shouldNotGroupWhenFull: true,
    items: [
      // 'heading', '|',
      // , 'fontsize', '|',
      // 'bold', 'italic', 'strikethrough', 'underline', 'subscript', 'superscript', '|',
      // 'link', '|',
      // 'outdent', 'indent', '|',
      // 'bulletedList', 'numberedList', 'todoList', '|',
      // 'code', 'codeBlock', '|',
      // 'insertTable', '|',
  
      "heading",
      'fontfamily',
      "fontsize",
      "fontColor",
      "fontBackgroundColor",
      "alignment",
      "outdent",
      "indent",
      "|",
      "Subscript",
      "Superscript",
      "Underline",
      "horizontalLine",
      "bold",
      "italic",
      "link",
      "|",
      "bulletedList",
      "numberedList",
      "|",
      "imageUpload",
      'imageStyle:full',
      'imageStyle:side',
      'imageTextAlternative',
      'imageResize',
      "linkImage",
      "mediaEmbed",
      "imageEdit",
      '|',
      "insertTable",
      "blockQuote",
      "undo",
      "redo",
      "|",
      "MathType",
      "ChemType",
      'htmlEmbed',
      "insertDiv",
      "findAndReplace",
      "lineHeight",
    ]
  };
  
  export const fontFamilies = [
    'default',
    'MathJax_Main',
    'B_Nazi',
    'IRANSansWebFaNum',
    'IRANSansWebFaNum_Bold',
    'IRANSansWebFaNum_Light',
    'Tahoma',
    'B Koodak',
    'B Zar',
    'B Titr',
    'IRANSansWeb_UltraLight',
    'B Arab Style', 'B Arash', 'B Aria', 'B Arshia', 'B Aseman', 'B Badkonak',
    'B Badr', 'B Baran', 'B Bardiya', 'B Cheshmeh', 'B Chini', 'B Compset',
    'B Davat', 'B Elham', 'B Elm', 'B Esfahan', 'B Fantezy', 'B Fardosi',
    'B Farnaz', 'B Haleh', 'B Hamid', 'B Helal', 'B Homa', 'B Jadid',
    'B Jalal', 'B Kaj', 'B Kamran', 'B Karim', 'B Kaveh', 'B Kidnap',
    'B Kourosh', 'B Lotus', 'B Mah', 'B Mahsa', 'B Majid shadow',
    'B Mashhad', 'B Masjed', 'B Medad', 'B Mehr', 'B Mitra', 'B Moj',
    'B Morvarid', 'B Narenj', 'B Narm', 'B Nasim', 'B Nazanin',
    'B Nazanin-Arabi', 'B_Nazi', 'B Niki', 'B Nikoo', 'B Paatch', 'B Rose',
    'B Roya', 'B Sahar', 'B Sahra', 'B Sara', 'B Sepideh', 'B Setareh',
    'B Shadi', 'B Shiraz', 'B Siavash', 'B Sina', 'B Sooreh', 'B Sorkhpust',
    'B Tabassom', 'B Tanab', 'B Tafwig Outline', 'B Tehran', 'B Tir',
    'B Traffic', 'B Vahid', 'B Vosta', 'B Yagut', 'B Yekan', 'B Zaman',
    'B Ziba',
    // ...
  ]